import grTextInput from "@/domain/icon/svg/gradient/gr-text-input";
import grTrash from "@/domain/icon/svg/gradient/gr-trash";
import grCart from "@/domain/icon/svg/gradient/gr-cart";
import grCameraOff from "@/domain/icon/svg/gradient/gr-camera-off";
import grInbox from "@/domain/icon/svg/gradient/gr-inbox";
import grCheckCircleBroken from "@/domain/icon/svg/gradient/gr-check-circle-broken";
import grFileSearch from "@/domain/icon/svg/gradient/gr-file-search";
import grFaceFrown from "@/domain/icon/svg/gradient/gr-face-frown";
import grAlertTriangle from "@/domain/icon/svg/gradient/gr-alert-triangle";
import grAnonymize from "@/domain/icon/svg/gradient/gr-anonymize";
import grBell from "@/domain/icon/svg/gradient/gr-bell";
import grAlarmClock from "@/domain/icon/svg/gradient/gr-alarm-clock";
import grStars  from "@/domain/icon/svg/gradient/gr-stars";
import grClockForward from "@/domain/icon/svg/gradient/gr-clock-forward";
import grLogin from "@/domain/icon/svg/gradient/gr-login";
import grMail05 from "@/domain/icon/svg/gradient/gr-mail-05";
import grShield from "@/domain/icon/svg/gradient/gr-shield";
import grCamera from "@/domain/icon/svg/gradient/gr-camera";
import grCameraPlus from "@/domain/icon/svg/gradient/gr-camera-plus";
export const _icons = {
    grCameraPlus,
    grCamera,
    grTextInput,
    grMail05,
    grTrash,
    grCart,
    grCameraOff,
    grInbox,
    grCheckCircleBroken,
    grFileSearch,
    grFaceFrown,
    grAlertTriangle,
    grAnonymize,
    grBell,
    grAlarmClock,
    grStars,
    grClockForward,
    grLogin,
    grShield
}